export default __webpack_public_path__ + "static/metallocherepica-96999957f3b4a1da308573bebe7d565d.jpg";